import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import printPretty from '../Utils/LogUtil'

export interface ChartDataRes {
  timestamp: number
  second: number
  amm: number | null
}

export interface ChartBodyRes {
  data?: ChartDataRes[]
}

export interface ChartRes {
  status: number
  body: ChartBodyRes
}

export interface ChartReq {
  chart_type: number
  end_date: number
  start_date: number
  data_type: number
}

const TOKEN =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZS1nZW5raS5nZW5raW1pcnUuanBcL2FwaVwvdjFcL2xvZ2luIiwiaWF0IjoxNjc4Njk5NTc5LCJleHAiOjE2ODEyOTE1NzksIm5iZiI6MTY3ODY5OTU3OSwianRpIjoib1BibnBFbkFRcEZuWnBqaSIsInN1YiI6MTMxNiwicHJ2IjoiYzhlZTFmYzg5ZTc3NWVjNGM3Mzg2NjdlNWJlMTdhNTkwYjZkNDBmYyJ9.N0Pgh4771mCiNtgp8eWzPPdFexMg9XmIctHhKQJjjEA'

export const genkiApi = createApi({
  reducerPath: 'genkiApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://de-genki.genkimiru.jp/api/v1',
  }),
  endpoints: (builder) => ({
    getChartData: builder.query<ChartRes, ChartReq>({
      query: (arg) => {
        let param = { ...arg }

        printPretty('useGetChartDataQuery', '')
        // printPretty('getChartData()')
        // printPretty('param', param)

        return {
          url: `user/my_data`,
          params: param,
          headers: { Token: TOKEN },
        }
      },
    }),

    chartData: builder.mutation<ChartRes, ChartReq>({
      query: (arg) => {
        let param = { ...arg }

        printPretty('--------------------genkiApi------------------------', '')
        printPretty('chartData', '')
        // printPretty('getChartData()')
        // printPretty('param', param)

        return {
          url: `user/my_data`,
          params: param,
          headers: { Token: TOKEN },
          method: 'GET',
        }
      },
      invalidatesTags: ['amm'],
    }),
  }),
  tagTypes: ['amm'],
})

export const { useGetChartDataQuery, useChartDataMutation } = genkiApi
